export const EventBars = ({ events, total }) => {
  const max = Math.max(1, ...events.map((e) => e.count));
  return (
    <section className="stats-card" data-testid="stats-event-bars">
      <div className="stats-card-head">
        <h2>Clics por botón</h2>
        <span>{total.toLocaleString("es-MX")} en total</span>
      </div>
      <ul className="stats-bars">
        {events.map(({ event, label, count }) => {
          const isWa = event.includes("whatsapp") || event.includes("asesor") || event === "cierre-necesito-ayuda";
          const pct = total ? Math.round((count / total) * 100) : 0;
          return (
            <li key={event} className="stats-bar-row" data-testid={`stats-event-${event}`}>
              <div className="stats-bar-meta">
                <span className="stats-bar-label">
                  <i className={isWa ? "fab fa-whatsapp" : "fas fa-external-link-alt"} /> {label}
                </span>
                <span className="stats-bar-count" data-testid={`stats-event-${event}-count`}>
                  {count.toLocaleString("es-MX")} <small>({pct}%)</small>
                </span>
              </div>
              <div className="stats-bar-track">
                <div
                  className={`stats-bar-fill ${isWa ? "wa" : ""}`}
                  style={{ width: `${(count / max) * 100}%` }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default EventBars;
